<template>
  <div class="animated fadeIn">
    <div class="card-group" >
        <b-card class="card col-md-3 mr-1 pl-0 pr-0 ml-0 card h-100" style="min-width:412px;  min-height: 85vh;">
          <!--SEARCH-->
          <div slot="header" style="height: 30px; background-color: #F0F3F5 !important; ">
            <b-row class="d-flex">
              <div class="ml-3 mr-1 mt-1 mb-1">
              <span style="font-weight: bold;">
            Search Criteria
              </span>
            </div>
              <div class="ml-auto mr-3 pt-1 pb-1">
                <button v-shortkey="['alt', 'r']"
                      class="btn btn-primary text-white pull-right btn-calculate"
                      @click="runScan()"
                      @shortkey="runScan()"
                      :disabled="!canScan">
                <!--<small v-if="!scanLoading">(alt + r)</small>-->
                <transition name="expand-button">
                  <span v-if="state.scanLoading">
                    <i title="Calculating" class="fa fa-circle-o-notch fa-spin mr-2"></i>
                    <span>Calculating...</span>
                  </span>
                  <span v-else>
                    <i class="fa fa-caret-square-o-right fa-lg mr-2"></i>
                    <span>Calculate</span>
                  </span>
                </transition>
              </button>
              </div>
            </b-row>
          </div>
          <div class="md-0">
            <b-col md="12">
              <!--<b-input-group>
                <b-form-checkbox id="chkUseMarse"
                                 v-model="Status"
                                 name="chkUseMarse"
                                 value="MARSE"
                                 unchecked-value="DAEDALUS">
                  USE MARSE
                </b-form-checkbox>
              </b-input-group>-->
              <!-- ACCOUNT LOOKUP -->
              <b-input-group>

                <!--:state="isValidVINNumber()"-->

                <b-input-group-append>
                  <button v-shortkey="['alt', 's']"
                          @shortkey="getDealerAccountNumber()"
                          class="btn btn-square btn-primary btn-block btn-search"
                          @click="getDealerAccountNumber()">
                    <!--
          <i v-if="scanLoading" title="Run Scan" class="fa fa-circle-o-notch fa-spin"></i>
      -->
                    <transition name="expand-button">
                      <span v-if="state.vinSearchLoading">
                        <i title="Lookup account by VIN (alt + s)" class="fa fa-circle-o-notch fa-spin"></i>
                      </span>
                      <span v-else>
                        <i title="Lookup account by VIN (alt + s)" class="fa fa-search"></i>
                      </span>
                    </transition>
                  </button>
                </b-input-group-append>
                <b-form-input id="inputVinNumber"
                              ref="inputVinNumberRef"
                              v-model="request.selectedVinNumber"
                              aria-describedby="inputVinNumber"
                              @keyup.native.enter="onEnter"
                              placeholder="Enter a VIN number"
                              lazy-formatter
                              @change="inputValueChanged()" style="border-radius: 0px 3px 3px 0px !important; border-left: none !important;"></b-form-input>

                <!--
      <b-form-invalid-feedback id="inputVinNumber">
        Invalid VIN number
      </b-form-invalid-feedback>
  -->
              </b-input-group>
<!--
              <b-form-input v-bind:class="{'bg-warning': isAccount}" title="Dealer Account #" v-model="request.dealerAccountName" disabled="disabled" placeholder="Dealer Account#">
                {{request.dealerAccountName}}
                {{makeModelTrim}}
              </b-form-input>
              -->
              <div class="mt-3 card-dropdown" style="background-color: #f0f3f5;">
              <div v-if="isMakeModelTrim" class="m-1 p-1 ">
                <div class="m-0">
                <Strong>Dealer Information:</Strong> {{request.dealerAccountName}}
                </div>
                <div class="mt-1 mb-0 ml-0 mr-0">
                <Strong>Vehicle Info:</Strong> {{makeModelTrim}}
                </div>
              </div>
              </div>
              <div>
                <b-row class="mt-3">
                  <b-col>
                    <span>Dealer Zip:</span>
                    <b-form-input class="mt-2 card-dropdown"
                                  id="txtDealerZip"
                                  v-model="request.dealerZip"
                                  type="number"
                                  max="99950"
                                  :disabled="!canFilter"
                                  @change="inputValueChanged()">
                    </b-form-input>
                  </b-col>
                  <b-col>
                    <span>Customer Zip:</span>
                    <b-form-input class="mt-2 card-dropdown"
                                  id="txtCustomerZip"
                                  v-model="request.customerZip"
                                  type="number"
                                  max="99950"
                                  :disabled="!canFilter"
                                  @change="inputValueChanged()">
                    </b-form-input>
                  </b-col>
                </b-row>
                <!--<hr />
                <b-row>
                  <b-col>
                    <span>Customer Cash:</span>
                    <msis-currency-input class="mt-2"
                                         :disabled="!canFilter"
                                         v-model="request.customerCash"></msis-currency-input>
                  </b-col>
                <!--SELECT CREDIT SCORE-->
                <b-row class="mb-2 mt-3">
                  <div class="ml-3 mr-0 pr-0" style="text-align: left; width:180px; ">
                  <span>Credit score:</span>
                  </div>
                </b-row>
                <div  class="mb-2">
                  <b-form-input id="inputLazy"
                                v-model="request.selectedCreditScore"
                                type="number"
                                step="10"
                                placeholder="Enter a credit score"
                                aria-describedby="inputCreditOutOfRange"
                                :state="isValidCreditScore()"
                                :disabled="!canFilter"
                                lazy-formatter
                                @change="inputValueChanged()" class="card-dropdown"></b-form-input>
                  <b-form-invalid-feedback id="inputCreditOutOfRange">
                    Selected credit score number is out of range.
                  </b-form-invalid-feedback>
                </div>
              </div>

              <div class="mt-3">
                <div v-if="showMileagePlus">
                  <b-form-checkbox v-model="showMileagePlus"
                                   :disabled="!canFilter" />
                  <span style="vertical-align: top;cursor: pointer"
                        @click="showMileagePlus = !showMileagePlus"
                        :disabled="!canFilter">
                    Annual Mileage: Custom
                  </span>

                  <b-form-input id="inputLazy"
                                v-model="request.selectedMileage"
                                type="range"
                                placeholder="Enter mileage"
                                aria-describedby="inputLazyHelp"
                                lazy-formatter
                                :disabled="!canFilter"
                                step="500"
                                min="17500"
                                max="25000"
                                @change="inputValueChanged()" class="card-dropdown"></b-form-input>

                  <b-form-input id="inputLazy"
                                v-model="request.selectedMileage"
                                :disabled="!canFilter"
                                type="number"
                                step="500"
                                placeholder="Enter mileage"
                                aria-describedby="inputLazyHelp"
                                lazy-formatter
                                @change="inputValueChanged()" class="card-dropdown"></b-form-input>

                </div>

                <div v-else>
                  <span>Annual Mileage:</span>
                  <b-form-select ref="selectMileageRef"
                                 v-model="selectedMileageOption"
                                 :options="mileageOptions"
                                 :disabled="!canFilter"
                                 class="mt-2 card-dropdown"
                                 @change.native="mileageChanged($event);inputValueChanged()">
                  </b-form-select>
                </div>
              </div>

            <div class="mt-3">
              <button class="btn btn-primary text-white card-dropdown" style="background-color: #0060A8; !important;"
                      @click="getRebateInformation()"
                      v-shortkey="['alt', 'e']"
                      @shortkey="hotKeyGetRebateInformation()"
                      :disabled="!canViewRebates">
                <span v-if="state.rebatesLoading">
                  <i title="View Rebates" class="fa fa-circle-o-notch fa-spin mr-2"></i>
                  <span>Loading...</span>
                </span>
                <span v-else>
                  <i title="View Rebates" class="fa fa-dollar fa-lg mr-2"></i>
                  <span>Rebates</span>
                </span>
              </button>
              <strong class="pull-right m-1">
                <a href="#" @click="restoreDefaults" style="color: #004173;">
                  (Clear Criteria)
                </a>
              </strong>
              <!--<b-button @click="response.SelectedRebates = null"
                        :variant="'secondary'"
                        :disabled="response.SelectedRebates === null">
                <i class="fa fa-remove fa-lg mr-2"></i>Remove Rebates
              </b-button>-->
              <!-- VIEW LOOKUP INFORMATION

              fa fa-money fa-lg
                          -->
              <!--<transition name="fade">
                <div v-if="state.showLookupView">
                  <hr />
                  <b-dropdown id="ddlAccountLookup" text="View">
                    <b-dropdown-item v-b-modal.jsonInfoDialog @click="showLookupRequest()">Account Lookup Request</b-dropdown-item>
                    <b-dropdown-item v-b-modal.jsonInfoDialog @click="showLookupResponse()">Account Lookup Response</b-dropdown-item>
                  </b-dropdown>
                </div>
              </transition>-->
              <!--TODO: sk- delete this if not used-->
              <!--<p>
                ← Go back to documentation help
              </p>-->
          </div>
              <!-- This needs to be here to trigger auto scroll -->
              <div style="display: hidden; height: 50px;">
              </div>
            </b-col>
          </div>
        </b-card>
        <!--SCAN-->
        <b-card class="card">
          <div slot="header" style="height: 30px;">
            <b-row class="d-flex mr-1">
              <div class="mt-1 mb-1 mr-1 ml-3">
                <span style="font-weight: bold;">
                  Scan Results
                  <!--<small v-if="response.SelectedRebates != null">(Rebates applied)</small>-->
                </span>
                </div>
              <div class="ml-auto pt-1 pb-1 pr-2">
                <button class="btn btn-secondary btn-json"
                        v-b-modal.jsonInfoDialog
                        @click="showScanRequest()">
                  <span>JSON Request</span>
                </button>
              </div>
                <div class="pl-0 pt-1 pb-1">
                <button class="btn btn-secondary btn-json"
                        v-b-modal.jsonInfoDialog
                        @click="showScanResponse()"
                        :disabled="runScanJSON.runScanResponse.length === 0">
                  <span>JSON Response</span>
                </button>
              </div>

            </b-row>
          </div>

          <div class="card-deck">

              <!--TABLE 1 - Lease-->
              <div class="card d-flex p-0 ml-sm-1 mr-sm-0" style="min-width:400px;">
                <div class="card-header">
                  <span style="font-weight: bold;">Lease</span>
                </div>
                <div class="card-body">
                <table class="tg"  cellspacing="1" cellpadding="5">
                  <tr>
                    <td v-for="header, index in getLeaseColumns" :key="`leaseColumn-${header.header}`">
                      <span v-if="index > 0">
                        <b-form-select v-model="header.header"
                                       @change.native="columnChanged('lease', index)"
                                       :options="getCashOptions('lease', index)"
                                       class="mb-2 selectwidthauto card-dropdown">
                        </b-form-select>
                      </span>
                    </td>
                  </tr>
                  <tr v-for="row, index in getLeaseRows" :key="`leaseRow-${row.Term}`">
                    <td v-if="!isNaN(row.Term)">
                      <b-form-select v-model="row.Term"
                                     @change="rowChanged($event, 'lease', index)"
                                     :options="getTermOptions('lease', index)"
                                     sm="4"
                                     class="mb-2 selectwidthauto card-dropdown">
                      </b-form-select>
                    </td>
                    <td v-for="column, index2 in row.Programs">
                      <div v-if="!isNaN(row.Term)">
                        <span v-if="!isChanged('lease', lease.fields[index2+1], row)"
                              @click="onClickedProgram('lease', lease.fields[index2+1].header, column, row)"
                              style="cursor: pointer">
                          <span v-if="column.Lender" v-b-tooltip.hover :title="`${column.Lender}`">
                            ${{typeof column.Payment === 'undefined' ? '0.00' : column.Payment }}
                          </span>
                          <span v-else>
                            ${{typeof column.Payment === 'undefined' ? '0.00' : column.Payment }}
                          </span>
                        </span>
                        <span v-else style="font-weight: bold">$0.00</span>
                      </div>
                    </td>
                  </tr>
                </table>
                  </div>
              </div>
              <div class="card d-flex p-0 ml-sm-1 mr-sm-0" style="min-width:400px;">
                <div class="card-header">
                  <span style="font-weight: bold;">
                  Finance
                  </span>
                </div>
                <div class="card-body">
                <!--TABLE 2 - Finance-->
                <table class="tg" cellspacing="1" cellpadding="5">
                  <tr>
                    <td v-for="header, index in getFinanceColumns" :key="`financeColumn-${header.header}`">
                      <span v-if="index > 0">
                        <b-form-select v-model="header.header"
                                       :options="getCashOptions('finance', index)"
                                       @change.native="columnChanged('finance', index)"
                                       class="mb-2 selectwidthauto card-dropdown">
                        </b-form-select>
                      </span>
                    </td>
                  </tr>

                  <tr v-for="row, index in getFinanceRows" :key="`financeRow-${row.Term}`">
                    <td>
                      <b-form-select v-model="row.Term"
                                     @change.native="rowChanged($event, 'finance', index)"
                                     :options="getTermOptions('finance', index)"
                                     :ref="'financeRow' + index"
                                     class="mb-2 selectwidthauto card-dropdown">
                      </b-form-select>
                    </td>

                    <td v-for="column, index2 in row.Programs">
                      <div v-if="!isNaN(row.Term)">
                        <span v-if="!isChanged('finance', finance.fields[index2+1], row)"
                              @click="onClickedProgram('finance', finance.fields[index2+1].header, column, row)"
                              style="cursor: pointer">
                          <span v-if="column.Lender" v-b-tooltip.hover :title="`${column.Lender}`">
                            ${{typeof column.Payment === 'undefined' ? '0.00' : column.Payment }}
                          </span>
                          <span v-else>
                            ${{typeof column.Payment === 'undefined' ? '0.00' : column.Payment }}
                          </span>
                        </span>
                        <span v-else style="font-weight: bold">$0.00</span>
                      </div>
                    </td>
                  </tr>
                </table>
                </div>
              </div>
              <div class="card d-flex col-md-2 p-0 ml-sm-1" style="min-width:280px;">
                <div class="card-header">
                  <!--TABLE 3 - Cash Deal-->
                  <!--<i class="fa fa-dollar"></i>-->
                  <!--<strong>Cash Deal</strong>-->
                  <span style="font-weight: bold;">Cash Deal</span>
                </div>
                <div class="card-body">
                  <table class="w-100">
                    <tbody>
                    <tr>
                      <td>MSRP</td>
                      <td>&nbsp;</td>
                      <td align="right" @click="showAlert()">{{toCurrency(cashDeal.VehicleMSRP == 0 ? '0.00' : cashDeal.VehicleMSRP)}}</td>
                    </tr>
                    <tr>
                      <td><span v-if="cashDeal.VehicleMSRP >= cashDeal.SellingPrice ">Discount</span><span v-if="cashDeal.VehicleMSRP < cashDeal.SellingPrice">Market Adjustment</span></td>
                      <td align="center"><span v-if="cashDeal.VehicleMSRP >= cashDeal.SellingPrice ">-</span><span v-if="cashDeal.VehicleMSRP < cashDeal.SellingPrice ">+</span></td>
                      <td align="right">
                        <span v-if="cashDeal.VehicleMSRP >= cashDeal.SellingPrice" >{{toCurrency(cashDeal.VehicleMSRP - cashDeal.SellingPrice == 0 ? '0.00' : cashDeal.VehicleMSRP - cashDeal.SellingPrice)}}</span>
                        <span v-if="cashDeal.VehicleMSRP < cashDeal.SellingPrice" >{{toCurrency(cashDeal.VehicleMSRP - cashDeal.SellingPrice == 0 ? '0.00' : cashDeal.SellingPrice - cashDeal.VehicleMSRP)}}</span></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>&nbsp;</td>
                      <td><div class="doubleline"></div></td>
                    </tr>
                    <tr>
                      <td>Selling Price</td>
                      <td align="center">=</td>
                      <td align="right">{{toCurrency(cashDeal.SellingPrice == 0 ? '0.00' : cashDeal.SellingPrice)}}</td>
                    </tr>
                    <tr>
                      <td>Rebates</td>
                      <td align="center">-</td>
                      <td align="right">{{toCurrency(cashDeal.Rebate == 0 ? '0.00' : cashDeal.Rebate)}}</td>
                    </tr>

                    <tr>
                      <td>{{ cashDeal.CityTaxDescription !== undefined && cashDeal.CityTaxDescription !== null ? cashDeal.CityTaxDescription : 'City Tax'}}</td>
                      <td align="center">+</td>
                      <td align="right">{{ cashDeal.CityTax !== undefined && cashDeal.CityTax !== null ? cashDeal.CityTax : '$0.00'}}</td>
                    </tr>

                    <tr>
                      <td>{{ cashDeal.CountyTaxDescription !== undefined && cashDeal.CountyTaxDescription !== null ? cashDeal.CountyTaxDescription : 'County Tax'}}</td>
                      <td align="center">+</td>
                      <td align="right">{{ cashDeal.CountyTax !== undefined && cashDeal.CountyTax !== null ? cashDeal.CountyTax : '$0.00'}}</td>
                    </tr>

                    <tr>
                      <td>{{ cashDeal.StateTaxDescription !== undefined && cashDeal.StateTaxDescription !== null ? cashDeal.StateTaxDescription : 'State Tax'}}</td>
                      <td align="center">+</td>
                      <td align="right">{{ cashDeal.StateTax !== undefined && cashDeal.StateTax !== null ? cashDeal.StateTax : '$0.00'}}</td>
                    </tr>
                    <tr>
                      <td>Registration Fee</td>
                    <td align="center">+</td>
                      <td align="right">{{toCurrency(cashDeal.RegistrationFee == 0 ? '0.00' : cashDeal.RegistrationFee)}}</td>
                    </tr>

                    <tr>
                      <td></td>
                      <td>&nbsp;</td>
                      <td><div class="doubleline"></div></td>
                    </tr>

                    <tr class="mt-2">
                      <td><strong>Total Cash Due</strong></td>
                      <td align="center">=</td>
                      <td align="right"><strong>{{toCurrency(cashDeal.TotalCashDue == 0 ? '0.00' : cashDeal.TotalCashDue)}}</strong></td>
                    </tr>

                    </tbody>
                  </table>
                </div>
              </div>

          </div>
        </b-card>

    </div>
    <div>
      <b-modal id="jsonInfoDialog" ref="jsonInfoDialogRef" size="lg" style="padding-right: 17px; padding-left: 17px;" title="Request/Response Data" hide-footer>
        <p v-if="dialogHeader"><strong>{{ dialogHeader }}</strong></p>
        <editor v-model="dialogText" @init="editorInit" style="font-size:18px;" width="1100" height="600" lang="JSON" theme="chrome"></editor>
        <b-row class="pull-right">
          <b-col>
            <b-btn class="mt-3" variant="secondary" block @click="$refs.jsonInfoDialogRef.hide()">Close</b-btn>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal id="rebateInformationDialog" ref="rebateInformationDialogRef" size="lg" style="padding-right: 17px; padding-left: 17px;" :static="true" >
        <div slot="modal-header">
          <h4>Rebate Info</h4>
        </div>
        <div style="padding: 10px">
          <iframe id="embeddedGrid" width="100%" height="740"></iframe>
        </div>
        <b-row slot="modal-footer" class="mr-2">
          <b-button :variant="'primary'"
                    @click="hideRebateDialogAndRefresh()"
                    class="mr-2">
            <span v-if="state.applyRebatesLoading">
              <i title="Run Scan" class="fa fa-circle-o-notch fa-spin mr-2"></i>
              <span>Applying...</span>
            </span>
            <span v-else>Apply</span>
          </b-button>
          <b-button :variant="'secondary'" @click="hideRebateDialog()" :disabled="state.applyRebatesLoading || state.scanLoading">Cancel</b-button>
        </b-row>
      </b-modal>

      <b-modal class="programInfoBody"
               id="programInformationDialog"
               ref="programInformationDialogRef"
               size="lg"
               title="Program Info"
               @shortkey="hideProgramDialog(function() { console.log('test') })"
               style="overflow: auto; font-size: small">
        <div slot="modal-header" style="width: 100%">
          <div class="float-left">
            <h4>Program Info</h4>
          </div>
          <div class="float-right">
            <b-button @click="pushToMDesking()"
                      v-shortkey="['alt', 'd']"
                      @shortkey="hotKeyPushToMDesking()"
                      class="btn btn-square btn-light bg-transparent no-shadow btn-block pull-right"
                      title="Push to mDesking"
                      style="border-color: transparent !important;">
              <!--:disabled="isProgramPushed()"-->
              <!--isProgramPushed(programId, term, cash) {-->
              <transition name="expand-button">
                <span>
                  <i v-if="!state.mDeskingPushLoading" class="fa fa-upload "></i>
                  <i v-else title="Push to mDesking" class="fa fa-circle-o-notch fa-spin"></i>
                </span>
              </transition>
              <span>&nbsp;Push to mDesking</span>
              <!--<span v-else>Pushed to mDesking</span>-->
            </b-button>
          </div>
        </div>

        <div class="overflow-y: auto;">
          <b-card class="card" style="height: 75vh;" no-body>
            <b-nav pills slot="header" v-b-scrollspy:nav-scroller>
              <div v-for="data, index in response.lastProgramResponse.UI">
                <b-nav-item :href="`#${data.Description}`" class="w-55">{{data.Description}}</b-nav-item>
              </div>
            </b-nav>
            <b-card-body class="card" style="position:relative; height:300px; overflow-y:scroll;">
              <b-card v-for="data, index in response.lastProgramResponse.UI" :id="`${data.Description}`" class="w-55 card">
                <strong v-if="data.Description === 'Lender Program Results'" slot="header">
                  <slot v-if="response.lastProgramResponse.BulletinCode === response.lastProgramResponse.BulletinNo">
                    {{response.lastProgramResponse.Description}} - ({{response.lastProgramResponse.BulletinCode}})
                  </slot>
                  <slot v-else>
                    {{response.lastProgramResponse.Description}} - ({{response.lastProgramResponse.BulletinCode}} {{response.lastProgramResponse.BulletinNo}})
                  </slot>
                </strong>
                <strong v-else slot="header">{{data.Description}}</strong>
                <b-row>
                  <div v-for="panel in data.Panels">
                    <b-col v-if="panel.Items != null && panel.Items.length > 0">
                      <strong>{{filterPanelHeader(panel.Description)}}</strong>
                      <table class="table">
                        <thead> <tr> <th></th> <th></th> <th></th> </tr> </thead>
                        <tbody>
                          <tr v-for="item in panel.Items">
                            <td>{{item.Description}} {{item.DescriptionValue}}</td>
                            <td><span> {{item.Symbol == '' ? '&nbsp;' : item.Symbol}}</span></td>
                            <td align="right">
                              <span v-if="item.Subkind === 1" style="color: red; font-weight:600">{{item.Value}}</span>
                              <span v-else-if="item.Subkind === 2" style="color: green; font-weight:600">{{item.Value}}</span>
                              <span v-else>{{item.Value}}</span>
                            </td>
                            <td v-if="item.Description === 'Amount'">
                              <div class="mb-5"></div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-col>
                  </div>
                </b-row>
              </b-card>
            </b-card-body>
          </b-card>
        </div>
        <b-row slot="modal-footer" style="width:100%;">
          <b-col class="col-lg-11">

          </b-col>
          <b-col>
            <b-button @click="hideProgramDialog()">Close</b-button>
          </b-col>
        </b-row>
      </b-modal>
    </div>
    <loading :show="showLoading" :label="txtLoading"></loading>
  </div>

</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import cSwitch from '../components/Switch'
import { isNullOrUndefined } from 'util'
import moment from 'moment'
import VueShortkey from 'vue-shortkey'
import VueToastr2 from 'vue-toastr-2'
import jQuery from 'jquery'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import { BasePageMixin } from '../mixin/BasePageMixin'

const ERROR_TYPE_SHOW = 0

const ERROR_TYPE_CONSOLE = 1

const ERROR_TYPE_TOAST = 2

const DEBUG = true // TODO:  change this back to false to deploy to production

window.toastr = require('toastr')

window.jQuery = jQuery

window.$ = jQuery

console.log(window.jQuery('body'))

Vue.use(VueToastr2)

Vue.use(VueShortkey)

function bestCopyEver (src) {
  return Object.assign({}, src)
}

const emptyString = ''

require(['brace/ext/emmet'], function (data) { // this is huge. so require it async is better
  window.emmet = data.emmet
})

const defaultSettings = {
  selectedMileage: 12000,
  selectedCreditScore: 720,
  selectedVinNumber: '',
  lastProgramRequest: null
}

const creditScoreInfo = [
  { eval: 'score >= 800', caption: 'Exceptional' },
  { eval: 'score >= 740 && score < 800', caption: 'Very Good' },
  { eval: 'score >= 670 && score < 740', caption: 'Good' },
  { eval: 'score >= 580 && score < 670', caption: 'Fair' },
  { eval: 'score >= 300 && score < 580', caption: 'Poor' }
]

/* Requests */
const GetScanInfoRequest = {
  'CreditScore': 720,
  'AutoRebateParams': { 'DealerZIP': 93012, 'ZIP': 93012 },
  'Location': { 'UseZIPForAutoRebate': true, 'AutoTaxRate': true, 'CustomerZIP': 93012, 'DealershipZIP': 93012 },
  'LeasePart': { 'AnnualMileage': 17500 },
  'RetailPart': {},
  'ScanMode': 2,
  'ScanType': 1,
  'Vehicle': { 'VIN': '' },
  'mPencil': {
    'LeasePart': { 'Cash': [1000, 2000, 3000, 4000], 'Term': [24, 36, 39, 42], 'UseLastCashAsOnePay': false },
    'RetailPart': { 'Cash': [0, 500, 1000, 1500], 'Term': [48, 60, 66, 72], 'Generic': null },
    'Spread': null
  },
  'OmitConfig': { 'FeeTax': true },
  'StateFeeTax': { 'CalculateRegistrationFee': true },
  "AdditionalParams": { 'LenderRegionDetectionType': 1}

}

const GetProgramInfoRequest = {

  'AutoRebateParams': {
    'DealerZIP': 93012, 'ZIP': 93012
  },
  'Filter': { 'IncludeOnlyTerm': 0, 'ProgramID': 0 },
  'Location': { 'AutoTaxRate': true, 'CustomerZIP': 93012, 'DealershipZIP': 93012 },
  'LeasePart': { 'AnnualMileage': 15000, 'CustomerCash': 500 },
  'RetailPart': { 'CustomerCash': 0 },
  'OmitScanResultField': { 'ProgramInfoUI': false },
  'ScanMode': 0,
  'ScanType': 1,
  'Vehicle': { 'VIN': '' },
  'mPencil': {
    'LeasePart': { 'Cash': [0, 500, 750, 1000], 'Term': [24, 36, 39], 'UseLastCashAsOnePay': false },
    'RetailPart': { 'Cash': [0, 500, 750, 1000], 'Term': [48, 60, 72], 'Generic': null },
    'Spread': null
  },
  'OmitConfig': { 'FeeTax': true },
  'StateFeeTax': { 'CalculateRegistrationFee': true }
}

const PushToMDeskingRequest = {
  'Request': {
    'AutoRebateParams': { 'DealerZIP': 93012, 'ZIP': 93012 },
    'Location': { 'AutoTaxRate': true, 'CustomerZIP': 93012, 'DealershipZIP': 93012 },
    'LeasePart': { 'AnnualMileage': 15000 },
    'RetailPart': {},
    'ScanMode': 2,
    'ScanType': 1,
    'Vehicle': { 'VIN': '' },
    'mPencil': {
      'LeasePart': { 'Cash': [0, 500, 750, 1000], 'Term': [24, 36, 39], 'UseLastCashAsOnePay': false },
      'RetailPart': { 'Cash': [0, 500, 750, 1000], 'Term': [48, 60, 72], 'Generic': null },
      'Spread': null
    },
    'OmitConfig': { 'FeeTax': true },
    'StateFeeTax': { 'CalculateRegistrationFee': true }
  },
  'Program': {
    'ProgramID': 39400700,
    'Term': 24,
    'mPencil': { 'ProgramIDIsLease': true, 'Cash': 500 }
  },
  'Greeting': 'Deal from API client<p><img src="http://help.mscanapi.com/media/mScanAPI.png"></img>'
}

const GetRebatesRequest = {
  'DateTimeStamp': '2018-12-05T20:09:04.043Z',
  'DealerZIP': 93033,
  'IncludeExpired': false,
  'Invoice': 27278,
  'MSRP': 26295,
  'OptionCode': null,
  'RegionID': 0,
  'VehicleID': 77465,
  'VehicleOwn': null,
  'VIN': '',
  'ZIP': 93033
}

/* Requests */
const GetCashDealInfoRequest = {
  'Filter': { 'IncludeOnlyTerm': 0 },
  'CreditScore': 720,
  'AutoRebateParams': { 'DealerZIP': 93012, 'ZIP': 93012 },
  'Location': { 'UseZIPForAutoRebate': true, 'AutoTaxRate': true, 'CustomerZIP': 93012, 'DealershipZIP': 93012 },
  'RetailPart': {'CustomerCash': 0, 'IsCashDeal': true},
  'IncludeScanResultField': { 'FullProgramDetails': true },
  'ScanMode': 1,
  'ScanType': 1,
  'DesiredValue': 0,
  'Vehicle': { 'VIN': ''},
  'OmitConfig': { 'FeeTax': true, 'Lease': {'OnlyAvailableLenders': true }, 'Retail': {'OnlyAvailableLenders': true } },
  'StateFeeTax': { 'CalculateRegistrationFee': true }
}

/* Lease defaults */
const defaultleaseRows = [ /* Note:  "Programs" are columns.  "Term" is the outermost column to the left */
  {
    Term: 24,
    Programs: [{ Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }],
    changed: false
  },
  {
    Term: 36,
    Programs: [{ Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }],
    changed: false
  },
  {
    Term: 39,
    Programs: [{ Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }],
    changed: false
  },
  {
    Term: 42,
    Programs: [{ Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }],
    changed: false
  }
]

const defaultFinanceTermOptions = [12, 18, 24, 30, 36, 42, 48, 54, 60, 63, 66, 72, 75, 78, 84, 88, 90, 96]

/* Finance defaults */
const defaultFinanceRows = [
  {
    Term: 48,
    Programs: [{ Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }],
    changed: false
  },
  {
    Term: 60,
    Programs: [{ Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }],
    changed: false
  },
  {
    Term: 66,
    Programs: [{ Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }],
    changed: false
  },
  {
    Term: 72,
    Programs: [{ Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }, { Payment: '0.00' }],
    changed: false
  }
]

const defaultLeaseTermOptions = [12, 15, 18, 21, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 48, 49, 50, 51, 52, 54, 57, 60, 66, 72]

const defaultCashDeal = { Rebate: 0.00, SalesTax: 0.00, VehicleMSRP: 0.00, TotalCashDue: 0.00, TaxesAndFees: 0.00, SellingPrice: 0.00, RegistrationFee: 0.00, CityTax: null, CountyTax: null, StateTax: null, CityTaxDescription: null, CountyTaxDescription: null, StateTaxDescription: null}

const defaultLastProgramResponse = { 'UI': [] }

const defaultLastGetRebatesResponse = {
  'data': {
    'CustomerTypeID': 9,
    'CustomerTypes': [
      {
        'ID': 9,
        'IsMostCommon': true,
        'Name': 'Individual'
      }
    ],
    'DealerZIP': 90210,
    'GeneralCompatibilities': [],
    'Rebates': [],
    'RegionID': 0,
    'Regions': null,
    'VehicleID': 77465,
    'ZIP': 90210
  },
  'Lease': {
    'Columns': [],
    'TotalCashNames': [{ 'DisplayName': 'TEST' }]
  },
  'Retail': {
    'Columns': [],
    'TotalCashNames': [{ 'DisplayName': 'TEST' }]
  },
  'VisibleRebates': []
}

String.prototype.replaceAll = function (search, replacement) {
  var target = this
  return target.replace(new RegExp(search, 'g'), replacement)
}

export default {
  components: {
    loading,
    cSwitch,
    editor: require('vue2-ace-editor'),
    shortkey: VueShortkey
  },
  created () { },
  mixins: [
    BasePageMixin
  ],
  data () {
    return {
      makeModelTrim: '',
      Status: 'MARSE',
      /* Cash deal table */
      cashDeal: defaultCashDeal,
      isAccount: false,
      /* Scan request JSON */
      request: bestCopyEver(defaultSettings),
      // {
      //  selectedMileage: 12000,
      //  selectedCreditScore: 720,
      //  selectedVinNumber: '',//'1C4PJLLB1JD510796', 1G1BF5SM0J7100346
      //  lastProgramRequest: null,
      //  customerZip: 93012,
      //  dealerZip: 93012
      //  // multi-region zipcode: 17402
      // },
      inventoryVehicle: null,
      response: {
        lastGetRebatesParamsResponse: defaultLastGetRebatesResponse,
        lastProgramResponse: defaultLastProgramResponse,
        lastProgramType: null,
        vehicleID: 0,
        SelectedRebates: null,
        RegionID: 0,
        HasRegion: false
      },

      dealerAccountName: '',

      pushToMDeskingJSON: {

      },

      accountLookupJSON: {
        accountLookupRequest: 'accountLookupRequest',
        accountLookupResponse: 'accountLookupResponse'
      },

      runScanJSON: {
        runScanRequest: '',
        runScanResponse: ''
      },

      programInfoJSON: {
        request: '',
        response: ''
      },

      errors: [],

      errMsg: '',

      /* Visibility of search items */
      showMileagePlus: false,
      showCreditPlus: false,

      // showScanView: false,

      selectedMileageOption: 12000,
      mileageOptions: [
        { value: 10000, text: '10,000' },
        { value: 12000, text: '12,000' },
        { value: 15000, text: '15,000' },
        { value: 17500, text: '17,500' },
        { value: 'Custom', text: 'Custom' }
      ],

      /* LEASE TABLE */
      lease: {
        fields: [
          { header: ' ', changed: false }, // should always be a whitespace
          { header: 0, changed: false },
          { header: 500, changed: false },
          { header: 1000, changed: false },
          { header: 1500, changed: false }
        ],

        cashOptions: [0,
          500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400,
          1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400,
          2500, 2600, 2700, 2800, 2900, 3000, 3100, 3200, 3300, 3400,
          3500, 3600, 3700, 3800, 3900, 4000, 4100, 4200, 4300, 4400,
          4500, 4600, 4700, 4800, 4900, 5000, 5100, 5200, 5300, 5400,
          5500, 5600, 5700, 5800, 5900, 6000, 6100, 6200, 6300, 6400,
          6500, 6600, 6700, 6800, 6900, 7000, 7100, 7200, 7300, 7400,
          7500, 7600, 7700, 7800, 7900, 8000, 8100, 8200, 8300, 8400,
          8500, 8600, 8700, 8800, 8900, 9000, 9100, 9200, 9300, 9400,
          9500, 9600, 9700, 9800, 9900, 10000, 10100, 10200, 10300, 10400,
          10500
        ],
        termOptions: defaultLeaseTermOptions,

        leaseRows: defaultleaseRows
      },

      /* FINANCE TABLE */
      finance: {
        fields: [
          { header: ' ', changed: false }, // should always be a whitespace
          { header: 1000, changed: false },
          { header: 2000, changed: false },
          { header: 3000, changed: false },
          { header: 4000, changed: false }
        ],

        cashOptions: [0, 500, 1000, 1500, 2000,
          2500, 3000, 3500, 4000, 4500,
          5000, 5500, 6000, 6500, 7000,
          7500, 8000, 8500, 9000, 9500,
          10000, 10500, 11000, 11500, 12000,
          12500, 13000, 13500, 14000, 14500],
        termOptions: defaultFinanceTermOptions,

        financeRows: defaultFinanceRows
      },

      showLoading: false,
      txtLoading: 'Loading...',

      scanLoading: false,

      state: {
        needsLookup: true,

        canFilter: false, //
        canScan: false, //
        usedScan: false,

        showRequestDialog: false,
        scanLoading: false,
        applyRebatesLoading: false,

        mDeskingPushLoading: false,
        vinSearchLoading: false,
        rebatesLoading: false,

        pushedPrograms: []
      },

      rebateDialog: {
        selectedCustomerType: 1,
        selectedRegion: 0
      },

      /* Dialog */
      dialogHeader: '',
      dialogText: '',
      selectedGenericRetailRebateID: 0
    }
  },

  methods: {
    /* Dialog */
    showProgramDialog () { this.$refs.programInformationDialogRef.show() },

    hideProgramDialog (callBack) {
      if (typeof callBack === 'function') callBack()

      window.location.hash = '#'

      this.$refs.programInformationDialogRef.hide()
    },

    showRebateInformationDialog () {
      var self = this
      setTimeout(function () {
        self.$refs.rebateInformationDialogRef.show()
      }, 500)
    },

    hideRebateDialog () {
      this.$refs.rebateInformationDialogRef.hide()
      this.response.SelectedRebates = null
    },

    async hideRebateDialogAndRefresh () {
      await this.getSelectedUIRebates()
    },

    scrollIntoView (evt) {
      // evt.preventDefault()
      /// /const href = evt.target.getAttribute('href')
      /// /const el = href ? document.querySelector(href) : null
      /// /if (el) {
      /// /  this.$refs.content.scrollTop = el.offsetTop
      /// /}
    },

    /* Hotkey */
    hotKeyPushToMDesking () {
      if (!this.canScan || this.response.lastProgramResponse === null) return

      this.pushToMDesking()
    },

    hotKeyGetRebateInformation () {
      if (!this.canViewRebates) return

      this.getRebateInformation()
    },

    /* Requests */
    getDealerAccountNumber () {
      if (typeof this.request.selectedVinNumber === 'undefined' ||
          this.request.selectedVinNumber === '' ||
          this.request.selectedVinNumber === null) return

      var self = this
      var postInfo = { vin: this.request.selectedVinNumber }
      this.state.vinSearchLoading = true
      this.request.dealerAccountNumber = 'Retrieving account info...'
      this.resetSessionData()

      axios.post('/api/Inventory/GetAccountByVIN', postInfo)
        .then(response => {
          if (self.hasError(response.data)) {
            self.debug('HAS ERROR!!!')
            self.request.dealerAccountNumber = 'Unable to locate VIN'
            self.handleError(response.data)
            self.state.needsLookup = false
            self.state.vinSearchLoading = false
            self.state.canFilter = false
            self.makeModelTrim = ''
            return
          }
          if (response.data.warning != undefined) {
            // self.handleException(response.data.warning);
            this.$toastr.warning(response.data.warning)
            this.isAccount = true
          } else {
            this.isAccount = false
          }

          self.state.vinSearchLoading = false
          self.state.canFilter = true
          self.state.needsLookup = false

          self.request.dealerAccountNumber = response.data.accountNumber
          self.request.dealerAccountName = response.data.accountNumber + ' ' + response.data.accountName
          self.request.dealerZip = response.data.accountZip
          self.request.customerZip = response.data.accountZip

          self.response.VehicleID = response.data.vehicleID

          self.inventoryVehicle = JSON.parse(response.data.inventoryVehicle)
          self.make = response.data.make
          self.model = response.data.model
          self.trim = response.data.trim
          self.year = response.data.year
          self.isNew = response.data.isNew
          self.setRebateFrameUrl()
          self.makeModelTrim = response.data.makeModelTrim
          this.persist()
        })
        .catch(error => {
          if (!this.isNullOrUndefined(error.Message)) {
            self.handleError(error)
            // self.handleException('An error occured during your request')
            self.makeModelTrim = ''
            self.state.vinSearchLoading = false
            self.state.canFilter = false
            self.state.needsLookup = true
            self.request.dealerAccountNumber = 'Lookup failed'
          }
        })
    },

    createRequest () {
      var request = bestCopyEver(GetScanInfoRequest)

      request.AutoRebateParams.DealerZIP = request.Location.DealershipZIP = parseInt(this.request.dealerZip)
      request.AutoRebateParams.ZIP = request.Location.CustomerZIP = parseInt(this.request.customerZip)

      if (this.response.SelectedRebates != null) {
        request.AutoRebateParams = null

        request.Rebates = {
          RebateValues: this.response.SelectedRebates,
          DealerZIP: this.request.dealerZip,
          ZIP: this.request.customerZip
        }

        if (this.response.HasRegion) {
          request.Rebates.RegionID = this.response.RegionID
        }

        if (this.selectedGenericRetailRebateID > 0) {
          request.RetailPart.RebateIDAPRForCashOrGeneric = this.selectedGenericRetailRebateID
        } else {
          delete request.RetailPart.RebateIDAPRForCashOrGeneric
        }
      } else {
        request.Rebates = null
        delete request.RetailPart.RebateIDAPRForCashOrGeneric
      }

      request.LeasePart.AnnualMileage = parseInt(this.request.selectedMileage)

      request.mPencil.LeasePart.Term = this.getTerms('lease')
      request.mPencil.LeasePart.Cash = this.getSelectedCashOptions('lease')
      request.mPencil.RetailPart.Term = this.getTerms('finance')
      request.mPencil.RetailPart.Cash = this.getSelectedCashOptions('finance')

      request.Vehicle.VIN = this.request.selectedVinNumber

      request.CreditScore = parseInt(this.request.selectedCreditScore)
      // if (this.Status == "MARSE") {
      request['Engine'] = 'Marse'
      // }

      return request
    },
    createCashDealRequest () {
      var request = bestCopyEver(GetCashDealInfoRequest)

      request.AutoRebateParams.DealerZIP = request.Location.DealershipZIP = parseInt(this.request.dealerZip)
      request.AutoRebateParams.ZIP = request.Location.CustomerZIP = parseInt(this.request.customerZip)

      if (this.response.SelectedRebates != null) {
        request.AutoRebateParams = null

        request.Rebates = {
          RebateValues: this.response.SelectedRebates,
          DealerZIP: this.request.dealerZip,
          ZIP: this.request.customerZip
        }

        if (this.response.HasRegion) {
          request.Rebates.RegionID = this.response.RegionID
        }
        if (this.selectedGenericRetailRebateID > 0) {
          request.RetailPart.RebateIDAPRForCashOrGeneric = this.selectedGenericRetailRebateID
        } else {
          delete request.RetailPart.RebateIDAPRForCashOrGeneric
        }
      } else {
        request.Rebates = null
        delete request.RetailPart.RebateIDAPRForCashOrGeneric
      }

      request.ScanMode = 1
      request.ScanType = 1

      request.Filter.IncludeOnlyTerm = 36
      request.Vehicle.VIN = this.request.selectedVinNumber
      request.CreditScore = parseInt(this.request.selectedCreditScore)
      request['Engine'] = 'Marse'
      return request
    },
    async getScanInformation () {
      var self = this
      this.state.scanLoading = true

      let hasError = false
      var request = this.createRequest()

      this.runScanJSON.runScanRequest = JSON.stringify(request, null, '\t')
      var newRequest = { account: this.request.dealerAccountNumber, info: request }

      this.debug('RUN SCAN!')

      // this.debug(request)

      try {
        const response = await axios.post('/api/RunScan', newRequest)
        self.state.pushedPrograms = []
        self.clearAllEdits()

        self.runScanJSON.runScanResponse = JSON.stringify(JSON.parse(response.data.data), null, '\t')

        var _response = JSON.parse(response.data.data)

        self.lease.leaseRows = _response.Lease.Terms
        self.resetTermOptions('lease')

        self.finance.financeRows = _response.Retail.Terms
        self.resetTermOptions('finance')
        self.cashDeal = _response.mPencil.CashPurchaseOption
      } catch (error) {
        self.state.scanLoading = false
        self.state.applyRebatesLoading = false
        hasError = true
        if (error.response.status === 400) {
          self.handleException('An error occured during your request: ' + error.response.data)
        } else {
          self.handleException('An error occured during your request ' + error)
        }
      }
      try {
        const _response = await self.getCashDealFromProgramInfo()
        if (_response !== null && _response !== undefined) {
          let cashDealProgram = _response.Retail.Terms[0].Programs[0].FullDetails.UI
          if (cashDealProgram !== null && cashDealProgram !== undefined) {
            let taxAndFees = cashDealProgram.find(x => x.Name === 'Fees')
            if (taxAndFees !== undefined && taxAndFees.Panels !== undefined && taxAndFees.Panels.find(x => x.Name === 'Fees') !== undefined) {
              let taxAndFeesPanels = taxAndFees.Panels.find(x => x.Name === 'Fees')
              if (taxAndFeesPanels.Items !== undefined) {
                let taxAndFeesPanelItems = taxAndFeesPanels.Items
                let cityTax = taxAndFeesPanelItems.find(x => x.Description.indexOf('City Tax') !== -1)
                let countyTax = taxAndFeesPanelItems.find(x => x.Description.indexOf('County Tax') !== -1)
                let stateTax = taxAndFeesPanelItems.find(x => x.Description.indexOf('State Tax') !== -1)
                console.log(countyTax)
                console.log(stateTax)
                if (cityTax !== undefined && cityTax !== null) {
                  self.cashDeal.CityTaxDescription = cityTax.Description.replace(':', '')
                  self.cashDeal.CityTax = cityTax.Value
                }
                if (countyTax !== undefined && countyTax !== null) {
                  self.cashDeal.CountyTaxDescription = countyTax.Description.replace(':', '')
                  self.cashDeal.CountyTax = countyTax.Value
                }
                if (stateTax !== undefined && stateTax !== null) {
                  self.cashDeal.StateTaxDescription = stateTax.Description.replace(':', '')
                  self.cashDeal.StateTax = stateTax.Value
                }
                // console.log(self.cashDeal)
              }
            }
          }
        }
      } catch (error) {
        hasError = true
        self.state.scanLoading = false
        self.state.applyRebatesLoading = false
      }

      if (hasError === false) {
        self.state.scanLoading = false
        self.state.usedScan = true
        self.clearAllEdits()
      }
    },
    async getCashDealFromProgramInfo () {
      const self = this
      let programInfo = this.createCashDealRequest(GetCashDealInfoRequest)
      let req = { account: this.request.dealerAccountNumber, info: programInfo }

      try {
        const response = await axios.post('/api/RunScan', req)
        if (!response.data.data.startsWith('{')) {
          // self.hideProgramDialog()
          self.$toastr.error(response.data.data, 'Error retrieving program info: ' + response.data.data)
          console.log('Error retrieving program info')
          return
        }

        let programInfoResult = JSON.parse(response.data.data)
        return programInfoResult
      } catch (error) {
        console.log('An error occured during your request')
        self.handleException('An error occured during your request ')
      }
    },
    getProgramInfo (type, cash, term, programId) {
      this.response.lastProgramResponse = defaultLastProgramResponse// defaultLastProgramResponse

      var self = this

      var programInfo = bestCopyEver(GetProgramInfoRequest)

      programInfo.Filter.IncludeOnlyTerm = term // term
      programInfo.Filter.ProgramID = programId // term
      programInfo.ScanMode = type === 'lease' ? 0 : 1

      var defaultPart = { CustomerCash: cash }

      programInfo.LeasePart = defaultPart
      programInfo.RetailPart = defaultPart
      programInfo.Vehicle.VIN = this.request.selectedVinNumber

      programInfo.AutoRebateParams.DealerZIP = programInfo.Location.DealershipZIP = parseInt(this.request.dealerZip)
      programInfo.AutoRebateParams.ZIP = programInfo.Location.CustomerZIP = parseInt(this.request.customerZip)
      programInfo.Location.UseZIPForAutoRebate = true

      if (this.response.SelectedRebates != null) {
        this.debug('this.response.SelectedRebates is not null')
        programInfo.AutoRebateParams = null

        programInfo.Rebates = {
          RebateValues: this.response.SelectedRebates,
          DealerZIP: this.request.dealerZip,
          ZIP: this.request.customerZip
        }

        if (this.response.HasRegion) {
          programInfo.Rebates.RegionID = this.response.RegionID
        }
      }

      if (type === 'lease') {
        programInfo.LeasePart = { AnnualMileage: parseInt(this.request.selectedMileage), CustomerCash: cash }
      } else {
        programInfo.RetailPart = { CustomerCash: cash }
      }

      this.request.lastProgramRequest = programInfo

      this.request.lastProgram = { type: type, id: programId, cash: cash, term: term }

      // if (this.Status == "MARSE")
      programInfo['Engine'] = 'MARSE'

      var req = { account: this.request.dealerAccountNumber, info: programInfo }

      axios.post('/api/GetProgramInfo', req)
        .then(response => {
          if (!response.data.data.startsWith('{')) {
            self.hideProgramDialog()
            self.$toastr.error(response.data.data, 'Error retrieving program info: ' + response.data.data)
            return
          }

          self.response.lastProgramResponse = JSON.parse(response.data.data)
          self.programInfoJSON.request = JSON.stringify(programInfo, null, '\t')
          self.programInfoJSON.response = JSON.stringify(self.response.lastProgramResponse, null, '\t')

          if (self.response.lastProgramResponse !== undefined) {
            var programInfoData = self.response.lastProgramResponse
            var registrationFees = programInfoData.UI.find(x => x.Name === 'RegistrationFees')
            if (registrationFees !== undefined) {
              registrationFees.Description = registrationFees.Description.replace(' Recap', '')
            }

            var lenderProgramResult = programInfoData.UI.find(x => x.Name === 'Body')
            var mSISRebatesRecap = programInfoData.UI.find(x => x.Name === 'MSISRebatesRecap')
            var cashEquityRecap = programInfoData.UI.find(x => x.Name === 'CashEquityRecap')
            var downPaymentRecap = programInfoData.UI.find(x => x.Name === 'DownPaymentRecap')
            var inceptionFees = programInfoData.UI.find(x => x.Name === 'InceptionFees')

            programInfoData.UI.forEach((_, index) => {
              this.$set(programInfoData.UI[index], 'order', 999)
            })
            // this.debug(JSON.stringify(self.selectedProgramInfo))
            if (lenderProgramResult !== undefined) { lenderProgramResult.order = 1 }
            if (mSISRebatesRecap !== undefined) { mSISRebatesRecap.order = 2 }
            if (inceptionFees !== undefined) { inceptionFees.order = 3 }
            if (registrationFees !== undefined) { registrationFees.order = 4 }

            if (cashEquityRecap !== undefined) { cashEquityRecap.order = 5 }
            if (downPaymentRecap !== undefined) { downPaymentRecap.order = 6 }
            programInfoData.UI = programInfoData.UI.sort((a, b) => (a.order > b.order) ? 1 : -1)
            self.response.lastProgramResponse = JSON.parse(JSON.stringify(programInfoData))
            self.programInfoJSON.response = JSON.stringify(self.response.lastProgramResponse, null, '\t')

            // console.log(self.programInfoJSON.response)
          }

          // if (this.Status == "MARSE") {
          // var RegistrationFeesSource = self.response.lastProgramResponse.RegistrationItem;

          // var RegistrationFeeItemTotal = {
          //  Description:"Total",
          //  Value: ""+self.response.lastProgramResponse.RegistrationFee
          // }
          // RegistrationFeesSource.push(RegistrationFeeItemTotal);
          // var RegistrationFeeItem = {
          //  Description: "Registration Fees",
          //  Value: "$" + self.response.lastProgramResponse.RegistrationFee
          // }

          // var Panel = {
          //  Description: "Fees",
          //  Items: this.getRegistrationFees(RegistrationFeesSource),
          //  Name: "Fees"
          // }
          // var RegistrationFees = {
          //  Description: "Registration Fees",
          //  Name: "Body",
          //  Panels: []
          // };
          // RegistrationFees.Panels.push(Panel);
          // self.response.lastProgramResponse.UI.push(RegistrationFees);
          // var InceptionFeesFromSource = this.GetInceptionFeesFromOriginal(RegistrationFees);
          // var InceptionFees = this.GetInceptionFees(InceptionFeesFromSource, RegistrationFeesSource);
          // InceptionFees = this.AddRegistrationFeesToInceptionFees(RegistrationFeeItem, InceptionFees);

          // this.SetInceptionFeesInOriginal(InceptionFees);

          // }

          self.showProgramDialog()
        })
        .catch(error => {
          self.handleException('An error occured during your request ')
          self.response.lastProgramResponse = defaultLastProgramResponse
        })
    },
    AddRegistrationFeesToInceptionFees (RegistrationFeeItem, InceptionFees) {
      var NewArray = []
      for (var i = 0; i < InceptionFees.length; i++) {
        var element = InceptionFees[i]
        if (i == 2) {
          NewArray.push(RegistrationFeeItem)
          NewArray.push(element)
        } else {
          NewArray.push(element)
        }
      }
      return NewArray
    },
    GetInceptionFees (InceptionFeesFromSource, RegistrationFees) {
      var InceptionFees = []
      console.log('RegistrationFees', RegistrationFees)
      for (var i = 0; i < InceptionFeesFromSource.length; i++) {
        var inceptionFee = InceptionFeesFromSource[i]
        var found = false
        for (var j = 0; j < RegistrationFees.length; j++) {
          var RegistrationFee = RegistrationFees[j]

          if (inceptionFee.Description == RegistrationFee.Description + ':') {
            found = true
          }
        }
        if (!found) {
          InceptionFees.push(inceptionFee)
        }
      }
      return InceptionFees
    },
    GetInceptionFeesFromOriginal (RegistrationFees) {
      var InceptionFees = []
      for (var i = 0; i < RegistrationFees.Panels[0].Items.length; i++) {
        // var RegistrationFee = RegistrationFees.Panels[0].Items[i];
        var BreakFor = false
        for (var j = 0; j < this.response.lastProgramResponse.UI.length; j++) {
          var UIElement = this.response.lastProgramResponse.UI[j]
          if (UIElement.Description == 'Inception Fees') {
            for (var x = 0; x < UIElement.Panels.length; x++) {
              var SubPanel = UIElement.Panels[x]
              if (SubPanel.Description == 'Fees') {
                return SubPanel.Items
              }
              if (BreakFor) {
                break
              }
            }
          }
        }
      }
      return InceptionFees
    },
    SetInceptionFeesInOriginal (InceptionFees) {
      for (var j = 0; j < this.response.lastProgramResponse.UI.length; j++) {
        var UIElement = this.response.lastProgramResponse.UI[j]
        if (UIElement.Description == 'Inception Fees') {
          for (var x = 0; x < UIElement.Panels.length; x++) {
            var SubPanel = UIElement.Panels[x]
            if (SubPanel.Description == 'Fees') {
              SubPanel.Items = InceptionFees
              return
            }
          }
        }
      }
    },
    getRegistrationFees (RegistrationFees) {
      var regfees = []
      for (var i = 0; i < RegistrationFees.length; i++) {
        var element = RegistrationFees[i]
        var rfee = {
          Description: element.Description,
          DescriptionValue: null,
          Value: '$' + element.Value
        }
        regfees.push(rfee)
      }
      return regfees
    },

    getRebateInformation () {
      var self = this
      GetRebatesRequest.DateTimeStamp = new Date()
      GetRebatesRequest.DealerZIP = parseInt(this.request.dealerZip)
      GetRebatesRequest.ZIP = parseInt(this.request.dealerZip)
      GetRebatesRequest.VIN = this.request.selectedVinNumber
      GetRebatesRequest.VehicleID = self.response.VehicleID
      // Vehicle ID
      this.state.rebatesLoading = true
      var req = {
        account: this.request.dealerAccountNumber,
        info: GetRebatesRequest
        // customerType: this.rebateDialog.selectedCustomerType
      }

      this.setRebateFrameUrl()

      axios.post('/api/GetRebatesParams', req)
        .then(response => {
          self.response.lastGetRebatesParamsResponse = JSON.parse(response.data)
          self.debug(self.response.lastGetRebatesParamsResponse)

          setTimeout(function () {
            self.showRebateInformationDialog()
            self.state.rebatesLoading = false
          }, 2000)
        })
        .catch(error => {
          self.state.rebatesLoading = false
          self.handleException('An error occured during your request ')
        })
    },

    async getSelectedUIRebates () {
      this.debug('/mRebateClient/SelectedRebates.aspx called!')
      var self = this
      var originalValue = this.canFilter
      this.state.canFilter = false
      this.state.applyRebatesLoading = true
      try {
        const response = await axios.get('/mRebateClient/SelectedRebates.aspx')

        self.state.rebatesLoading = false
        self.state.applyRebatesLoading = false
        self.response.SelectedRebates = response.data.rebates

        if (response.data.SelectedGenericRetailRebateID !== undefined &&
            response.data.SelectedGenericRetailRebateID !== null && parseInt(response.data.SelectedGenericRetailRebateID) > 0) {
          this.selectedGenericRetailRebateID = parseInt(response.data.SelectedGenericRetailRebateID)
        }

        self.response.RegionID = response.data.RegionID || 0
        self.response.HasRegion = typeof response.data.RegionID !== 'undefined'
        self.state.canFilter = originalValue

        self.$refs.rebateInformationDialogRef.hide()
        self.$toastr.success('Successfully applied rebates', 'Finished applying rebates')
        if (self.hasError(response)) {
          self.handleError(response)
        }
      } catch (error) {
        self.handleException('An error occured during your request ')
        self.state.canFilter = originalValue
        self.state.rebatesLoading = false
      }
    },

    setRebateFrameUrl () {
      document.getElementById('embeddedGrid').src = '/mRebateClient/Default.aspx?make=' + this.make +
          '&model=' + this.model +
          '&trim=' + this.trim +
          '&year=' + this.year +
          '&customerZip=' + this.request.customerZip +
          '&dealerZip=' + this.request.dealerZip
    },

    pushToMDesking () {
      if (this.isAccount) {
        if (!confirm('This vehicle belongs to an account you are not logged in to. Do you still wish to push to mDesking?')) {
          return
        }
      }
      var self = this

      var request = bestCopyEver(PushToMDeskingRequest)

      request.Request.CreditScore = parseInt(this.request.selectedCreditScore)
      request.Request.Vehicle.VIN = this.request.selectedVinNumber
      request.Request.Vehicle.UsedData = self.inventoryVehicle.UsedData
      request.Request.mPencil.LeasePart.Term = this.getTerms('lease')
      request.Request.mPencil.LeasePart.Cash = this.getSelectedCashOptions('lease')
      request.Request.mPencil.RetailPart.Term = this.getTerms('finance')
      request.Request.mPencil.RetailPart.Cash = this.getSelectedCashOptions('finance')

      request.Request.RetailPart = {}
      request.Request.LeasePart = { AnnualMileage: parseInt(this.request.selectedMileage) }
      request.Request.AutoRebateParams = {}
      request.Request.AutoRebateParams.DealerZIP = request.Request.Location.DealershipZIP = parseInt(this.request.dealerZip)
      request.Request.AutoRebateParams.ZIP = request.Request.Location.CustomerZIP = parseInt(this.request.customerZip)

      if (this.selectedGenericRetailRebateID !== undefined &&
        this.selectedGenericRetailRebateID !== null &&
        this.selectedGenericRetailRebateID > 0) {
        request.RetailPart.RebateIDAPRForCashOrGeneric = this.selectedGenericRetailRebateID
      }

      var lastProgram = this.request.lastProgram

      request.Program = {
        'ProgramID': lastProgram.id,
        'Term': lastProgram.term,
        'mPencil': {
          'ProgramIDIsLease': lastProgram.type === 'lease',
          'Cash': lastProgram.cash
        }
      }

      request.Customer = {
        'FirstName': 'API Demo',
        'LastName': 'Customer',
        'IntegratorType': 100
      }

      // user NotifyType = 1 for predifeined users in mdesking
      request.NotifyType = 1

      this.state.mDeskingPushLoading = true

      var req = { account: this.request.dealerAccountNumber, info: request }

      if (lastProgram.type === 'lease') {
        request.Request.LeasePart = {
          AnnualMileage: parseInt(this.request.selectedMileage),
          CustomerCash: 0
        }
      } else {
        request.Request.RetailPart = {
          CustomerCash: 0
        }
      }

      if (this.response.SelectedRebates != null) {
        request.Request.AutoRebateParams = null

        request.Request.Rebates = {
          RebateValues: this.response.SelectedRebates,
          DealerZIP: this.request.dealerZip,
          ZIP: this.request.customerZip
        }

        if (this.response.HasRegion) {
          request.Request.Rebates.RegionID = this.response.RegionID
        }

        request.Request.Filter = { ProgramID: lastProgram.id }
      } else request.Rebates = null

      this.request.lastPushToMDesking = request
      axios.post('/api/PushToMDesking', req)
        .then(response => {
          this.state.mDeskingPushLoading = false

          self.response.lastProgramResponse = JSON.parse(response.data.data)

          self.hideProgramDialog()

          self.$toastr.success('Successfully pushed 1 item to mDesking', 'Pushed to mDesking')

          this.state.pushedPrograms.push(lastProgram)
        })
        .catch(error => {
          this.state.mDeskingPushLoading = false
          self.$toastr.error(error, 'Error pushing 1 item to mDesking')
          self.hideProgramDialog()
        })
    },

    clearEdits (type) {
      var obj = eval('this.' + type)
      for (var i in obj[type + 'Rows']) { obj[type + 'Rows'][i].changed = false }
      for (var i in obj.fields) { obj.fields[i].changed = false }
    },

    clearAllEdits () {
      this.clearEdits('lease')
      this.clearEdits('finance')
    },
    async resetActiveLendersAllAccounts () {
      var self = this
      try {
        await axios.post('/api/lenders/ResetActiveLendersAllAccounts')
      } catch (error) {
        self.handleException('An error occured during your request ')
        // self.response.lastProgramResponse = defaultLastProgramResponse
      }
    },
    focusVin () {
      this.$refs.inputVinNumberRef.focus()
    },

    resetSessionData () {
      this.response.SelectedRebates = null
      this.response.RegionID = 0
      this.response.HasRegion = false
    },

    restoreDefaults () {
      this.state.needsLookup = true
      this.clearAllPrograms()
      this.clearCashDeal()
      this.request = bestCopyEver(defaultSettings)
      this.resetMakeModelTrim()
      this.resetActiveLendersAllAccounts()
      this.focusVin()
    },

    resetMakeModelTrim () {
      this.makeModelTrim = ''
    },

    clearAllPrograms () {
      this.lease.leaseRows = defaultleaseRows
      this.finance.financeRows = defaultFinanceRows
      this.finance.termOptions = defaultFinanceTermOptions
      this.lease.termOptions = defaultLeaseTermOptions
    },

    clearCashDeal () { this.cashDeal = bestCopyEver(defaultCashDeal) },

    getCreditScoreCaption (score) {
      if (score === null || typeof score === 'undefined') return

      for (var i in creditScoreInfo) {
        var creditScore = creditScoreInfo[i]
        if (eval(creditScore.eval)) {
          return creditScore.caption
        }
      }
    },

    getTerms (type) {
      var obj = eval('this.' + type + '.' + type + 'Rows')
      var ret = []
      for (var r in obj) {
        var row = obj[r]
        ret.push(row.Term)
      }
      return ret
    },

    getSelectedCashOptions (type) { // this function is for obtaining cash option parameters to pass to RunScan
      var obj = eval('this.' + type + '.fields')
      var ret = []
      for (var r in obj) {
        var row = obj[r]
        if (typeof row.header !== 'number') continue
        ret.push(row.header)
      }
      return ret
    },

    isProgramPushed () {
      var programs = this.state.pushedPrograms

      for (var i in programs) {
        var program = programs[i]
        var lastProgram = this.request.lastProgram
        if (program.id === lastProgram.id && program.term === lastProgram.term && program.cash === lastProgram.cash) { return true }
      }

      return false
    },

    isValidCreditScore () {
      return !(this.request.selectedCreditScore > 850 || this.request.selectedCreditScore <= 0) ? null : false
    },

    resetTermOptions (type) {
      var obj = eval('this.' + type)
      obj.termOptions = type === 'lease' ? defaultLeaseTermOptions : defaultFinanceTermOptions
    },

    getTermOptions (type, index) {
      var obj = eval('this.' + type)
      var termOptionsCopy = obj.termOptions.slice()
      var rows = eval('obj.' + type + 'Rows').slice()

      var neighboringSelections = []

      for (var i in rows) {
        var row = rows[i]
        var value = row.Term
        if (i == index) { continue }
        neighboringSelections.push(value)
      }

      for (var n in neighboringSelections) {
        var neighbor = neighboringSelections[n]
        var findValue = termOptionsCopy.indexOf(parseInt(neighbor))
        termOptionsCopy.splice(findValue, 1)
      }

      return termOptionsCopy
    },

    getCashOptions (type, index) {
      var obj = eval('this.' + type)
      var columnsCopy = eval('obj.fields').slice()
      var cashOptionsCopy = obj.cashOptions.slice()

      var info = {}
      var neighboringSelections = []

      for (var i in columnsCopy) {
        var column = columnsCopy[i]
        if (i == index || column.header === ' ') { continue }
        var value = column.header
        neighboringSelections.push(value)
      }

      for (var n in neighboringSelections) {
        var neighbor = neighboringSelections[n]
        var findValue = cashOptionsCopy.indexOf(parseInt(neighbor))
        cashOptionsCopy.splice(findValue, 1)
      }

      return cashOptionsCopy
    },

    runScan () {
      if (!this.canScan) return
      this.showVars()
      // this.showScanView = true
      this.getScanInformation()
      this.persist()
    },

    showScanRequest () {
      this.dialogHeader = 'Scan Request'
      var request = this.createRequest()
      this.runScanJSON.runScanRequest = JSON.stringify(request, null, '\t')
      this.dialogText = this.runScanJSON.runScanRequest
    },

    showScanResponse () {
      this.dialogHeader = 'Scan Response'
      this.dialogText = this.runScanJSON.runScanResponse
    },

    showProgramInfoRequest () {
      this.dialogHeader = 'Program Info Request'
      this.dialogText = this.programInfoJSON.request
    },

    showProgramInfoResponse () {
      this.dialogHeader = 'Program Info Response'
      this.dialogText = this.programInfoJSON.response
    },

    showLookupRequest () {
      this.dialogHeader = 'Lookup Request'
      this.dialogText = this.accountLookupJSON.accountLookupRequest
    },

    showLookupResponse () {
      this.dialogHeader = 'Lookup Response'
      this.dialogText = this.accountLookupJSON.accountLookupResponse
    },

    /* Error handling */
    hasError (response) {
      if (this.isNullOrUndefined(response)) return false

      this.debug(response)

      if (response.hasOwnProperty('ErrorType') && response.hasOwnProperty('Message')) { return true }

      return false
    },

    handleError (error) {
      if (error.ErrorType === ERROR_TYPE_SHOW) {
        console.error(error.Message)
        return
      }

      if (error.ErrorType === ERROR_TYPE_TOAST) {
        this.$toastr.error(error.Message)
        return
      }

      if (error.ErrorType === ERROR_TYPE_CONSOLE) {
        return
      }

      console.error(error.Message)
    },

    handleException (error) {
      console.error(error)
      this.$toastr.error(error)
      // this.clearRecords()
      this.showLoading = false
    },

    /* Rebates */

    /**
       * Gets all rebates where 'Selected' is true
       * @param rebates
       */
    getSelectedRebates (rebates) {
      if (this.isNullOrUndefined(rebates)) return []
      var l = []
      for (var i in rebates) {
        var rebate = rebates[i]
        if (rebate.Selected) l.push(rebate)
      }
      return l
    },

    findRebateCompatability (compatList, rebateId) {
      for (var i in compatList) {
        var compat = compatList[i]
        if (compat.RebateID === rebateId) return compat
      }
      return null
    },

    findCCRIncrementals (rebates) {
      var l = []
      for (var i in rebates) {
        var rebate = rebates[i]
        if (typeof rebate.CCRIncrementals === 'undefined' || rebate.CCRIncrementals === null || f.CCRIncrementals.length < 1) continue
        l.push(rebate)
      }
      return l
    },

    findCCRIncremental (rebates, id) {
      var l = []
      for (var i in rebates) {
        var rebate = rebates[i]
        if (rebate.ID != id || typeof rebate.CCRIncrementals === 'undefined' || rebate.CCRIncrementals === null || f.CCRIncrementals.length < 1) continue
        l.push(rebate)
      }
      return l
    },

    /**
       *
       * @param rebate Rebate
       * @param customerTypeId A CustomerTypeID that exists outside of previously specified 'rebate'
       */
    isCustomerTypeOk (rebate, customerTypeId) {
      if (rebate.CustomerTypes === null) return false

      for (var i in rebate.CustomerTypes) {
        if (rebate.CustomerTypes[i].ID === customerTypeId) return true
      }

      return false
    },

    isEliminated (data, rebate, customerTypeId) {
      if (data.CustomerTypes === null || data.CustomerTypes.length < 2) {
        return false
      }

      return !rebate.IsGeneric && !this.isCustomerTypeOk(rebate, customerTypeId)
    },

    getTermCellValue (row, col, data) { },

    getRebateTotalCellValue (row, col, data) { },

    getRebateCellValue (row, col, data) {
      var compat = this.findRebateCompatability(data.GeneralCompatibilities, col.ID) // Find compatabilities list of column using ID
      if (compat !== null) { // Check col compatabilities list for row id.. if not present, return N/A
        var list = compat.CompatibilityList
        var index = list.indexOf(row.ID)
        if (index === -1) return 'N/A'
      }

      if (this.isEliminated(data, row, data.CustomerTypeID)) { return 'cust.type' }

      // if (typeof row.Value === 'undefined' || row.Value  === null) return 'N/A'

      //  if (typeof row.Value.Values === 'undefined' || row.Value.Values === null) return 'N/A'

      if (this.isNullOrUndefined(row.Value.Values)) return 'N/A'

      if (row.Type === 4 && !row.Selected) return '-'

      return row.Value.Values[0].Value
    },

    getRebateRowStyle (row) { return row.Selected ? 'selectedRow' : '' },

    /* Misc */
    debug (txt) {
      if (this.isNullOrUndefined(DEBUG)) return

      if (DEBUG === false) { return }

      console.log(txt)
    },

    isNullOrUndefined (val) { return typeof val === 'undefined' || val === null },

    clearHashBang () { window.location.hash = '#' },

    parseJsonDate: function (jsonDateString) {
      if (jsonDateString === null || typeof jsonDateString === 'undefined') return 'N/A'

      return new Date(parseInt(jsonDateString.replace('/Date(', '')))
    },

    getFormattedDate (dateObj) {
      if (dateObj === null || typeof dateObj === 'undefined') return 'N/A'

      if (dateObj === 'N/A') return dateObj

      return (dateObj.getMonth() + 1) + '/' + dateObj.getDate() + '/' + dateObj.getFullYear()
    },

    toCurrency (value) {
      if (isNaN(value) || typeof value === 'undefined' || value === '' || value === null) return value

      value = this.roundFormat(value, 2)
      value = value.toString()

      var dec = value.includes('.') ? '' : '.00'

      return '$' + this.toCommas(value) + dec
    },
    roundFormat: function (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals)
    },

    toCommas (value) {
      if (value === null || typeof value === 'undefined') return 'N/A'

      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    isChanged (type, column, row) {
      return typeof column !== 'undefined' && typeof row !== 'undefined' && (column.changed || row.changed)
    },

    filterPanelHeader (header) {
      if (header === 'Advance') return 'Advance / Residual'
      if (header === 'Equity') return 'Cash / Equity'
      return header
    },

    showVars () {
      this.debug('runScanRequest = ' + this.runScanJSON.runScanRequest)
      this.debug('runScanResponse = ' + this.runScanJSON.runScanResponse)
      this.debug('accountLookupRequest = ' + this.accountLookupJSON.accountLookupRequest)
      this.debug('accountLookupResponse = ' + this.accountLookupJSON.accountLookupResponse)
    },

    editorInit: function () {
      require('brace/ext/language_tools')
      require('brace/mode/html')
      require('brace/mode/javascript')
      require('brace/mode/less')
      require('brace/theme/chrome')
    },

    /* Evt */
    onProgramClose () { window.location.hash = '#' },

    onEnter () { this.getDealerAccountNumber() },

    onClickedProgram (type, cash, col, row) {
      var id = col.ID
      if (typeof id === 'undefined') return
      var term = row.Term
      this.getProgramInfo(type, cash, term, id)
    },

    vinChanged () {
      // this.state.needsLookup = true
      // if (this.request.selectedVinNumber != )
    },

    inputValueChanged () {
      this.clearAllPrograms()
      this.clearCashDeal()
    },

    columnChanged (type, index) {
      var obj = eval('this.' + type)
      obj.fields[index].changed = true
    },

    rowChanged (event, type, index) {
      var obj = eval('this.' + type)
      var rows = eval('obj.' + type + 'Rows')
      rows[index].changed = true
    },

    /**
       *
       * @param o
       */
    mileageChanged (o) {
      this.selectedMileageOption = o.target.value
      this.request.selectedMileage = o.target.value
      this.showMileagePlus = this.selectedMileageOption === 'Custom'
      // this.state.canScan = true;
      if (this.showMileagePlus) { this.request.selectedMileage = 17500 }
    },
    persist () {
      this.SetLocalStorage('selectedVinNumber', this.request.selectedVinNumber)
      this.SetLocalStorage('selectedMileage', this.request.selectedMileage)
      this.SetLocalStorage('customerZip', this.request.customerZip)
      this.SetLocalStorage('dealerZip', this.request.dealerZip)
      this.SetLocalStorage('selectedCreditScore', this.request.selectedCreditScore)
      this.SetLocalStorage('inventoryVehicleIsNew', this.isNew)
    },
    async getUserFilledData () {
      if (this.GetLocalStorageWithExpiration('selectedVinNumber') !== null) {
        this.request.selectedVinNumber = this.GetLocalStorageWithExpiration('selectedVinNumber')
        this.getDealerAccountNumber()
      }
      if (this.GetLocalStorageWithExpiration('selectedMileage') !== null) {
        this.request.selectedMileage = parseInt(this.GetLocalStorageWithExpiration('selectedMileage'))
        this.selectedMileageOption = this.mileageOptions.find(m => m.value === this.request.selectedMileage).value
      }
      if (this.GetLocalStorageWithExpiration('customerZip') !== null) {
        this.request.customerZip = parseInt(this.GetLocalStorageWithExpiration('customerZip'))
      }
      if (this.GetLocalStorageWithExpiration('dealerZip') !== null) {
        this.request.dealerZip = parseInt(this.GetLocalStorageWithExpiration('dealerZip'))
      }
      if (this.GetLocalStorageWithExpiration('selectedCreditScore') !== null) {
        this.request.selectedCreditScore = parseInt(this.GetLocalStorageWithExpiration('selectedCreditScore'))
      }
      if (this.GetLocalStorageWithExpiration('inventoryVehicleIsNew') !== null) {
        this.isNew = this.GetLocalStorageWithExpiration('inventoryVehicleIsNew')
      }
    }
  },
  computed: {

    isMakeModelTrim () {
      return this.makeModelTrim !== undefined && this.makeModelTrim !== null && this.makeModelTrim.length > 0
    },
    /* View state */
    canPushToMDesking () { return this.state.scanLoading },

    canFilter () { return this.state.canFilter },

    canScan () {
      return this.canFilter &&
          this.request.selectedMileage !== 0 &&
          this.request.selectedVinNumber !== '' &&
          this.request.customerZip !== '' &&
          this.request.dealerZip !== '' &&
          !this.state.needsLookup
    },

    canViewRebates () { return this.canScan /* && this.state.usedScan */ },

    getCreditCaption () { return this.getCreditScoreCaption(this.request.selectedCreditScore) },

    /* Grids */
    isFinanceChanged () {
      var financeRows = this.finance.financeRows

      for (var index in financeRows) {
        var row = financeRows[index]
        if (row.changed) return true
      }

      var financeColumns = this.finance.fields
      for (var index in financeColumns) {
        var column = financeColumns[index]
        if (column.changed) return true
      }

      return false
    },

    isLeaseChanged () {
      var leaseRows = this.lease.leaseRows

      for (var index in leaseRows) {
        var row = leaseRows[index]
        if (row.changed) return true
      }

      var leaseColumns = this.lease.fields
      for (var index in leaseColumns) {
        var column = leaseColumns[index]
        if (column.changed) return true
      }

      return false
    },

    getFinanceRows () {
      this.finance.financeRows.sort(function (a, b) {
        return parseInt(a.Term) - parseInt(b.Term)
      })

      return this.finance.financeRows
    },

    getFinanceColumns () {
      this.finance.fields.sort(function (a, b) {
        if (a.header === ' ' || b.header === ' ') { return 0 }

        return a.header - b.header
      })

      return this.finance.fields
    },

    getLeaseRows () {
      this.lease.leaseRows.sort(function (a, b) {
        return parseInt(a.Term) - parseInt(b.Term)
      })

      return this.lease.leaseRows
    },

    getLeaseColumns () {
      this.lease.fields.sort(function (a, b) {
        if (a.header === ' ' || b.header === ' ') { return 0 }

        return a.header - b.header
      })

      return this.lease.fields
    }

  },
  created: function () {
    axios.get('/api/PageLoad')
  },
  mounted () {
    this.getUserFilledData()
    // console.log(this.$refs.programInformationDialogRef)
    // $(this.$refs.programInformationDialogRef).on("hidden.bs.modal", this.onProgramClose())

    // const lang = this.lang || 'text'
    // const theme = this.theme || 'github'

    // this.editor = window.ace.edit(this.editorId)
    // this.editor.setValue(this.content, 1)

    // this.editor.getSession().setMode(`ace/mode/${lang}`)
    // this.editor.setTheme(`ace/theme/${theme}`)

    // this.editor.on('change', () => {
    //  this.beforeContent = this.editor.getValue()
    //  this.$emit('change-content', this.editor.getValue())
    // })
  }
}

/* Currency control, not currently in use */
Vue.component('msis-currency-input', {
  props: ['value', 'disabled'],
  template: `
        <div>
            <input type="text" class="form-control" v-model="displayValue" :disabled="disabled" @blur="isInputActive = false" @focus="isInputActive = true"/>
        </div>`,
  data: function () {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function () {
        if (this.isInputActive) {
          // Cursor is inside the input field. unformat display value for user
          return this.value.toString()
        } else {
          // User is not modifying now. Format display value for user interface
          return '$ ' + this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
        }
      },
      set: function (modifiedValue) {
        // Recalculate value after ignoring "$" and "," in user input
        let newValue = parseInt(modifiedValue.replace(/[^\d\.]/g, ''))
        // Ensure that it is not NaN
        if (isNaN(newValue)) {
          newValue = 0
        }
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        this.$emit('input', newValue)
      }
    }
  }
})
</script>

<style>
  #rebateInformationDialog td {
    /*background-color: lightyellow;*/
  }

  .table th, .table td {
    padding: 0.25rem !important;
    vertical-align: top !important;
    border-top: none !important;
  }

  .tg {
    text-align: center;
  }

  .programInfoBody {
    max-height: calc(100vh - 225px);
  }

  .vl {
    border-left: 1px solid lightgray;
    height: 500px;
    position: absolute;
    left: 50%;
    top: 0;
  }

  /*.btn-primary {
    background-color: #0063a9 !important;
  }*/

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  strong {
    font-weight: 600 !important;
  }
  /*.card {
    box-shadow: 2px 2px 2px lightgrey;
  }*/

  /*.card .card {
      box-shadow: 0px 0px 0px black !important;
    }*/

  table span:hover {
    /*text-decoration: underline;*/
  }

  .wide-table {
    width: 100%
  }

  #programInformationDialog .modal-lg {
    max-width: 1600px;
  }

  #programInformationDialog .modal-body {
    padding: 0px !important;
  }

  #programInformationDialog .modal-header {
    border-bottom: 0px !important;
  }
  /* Rebate Dialog */
  #rebateInformationDialog .modal-lg {
    max-width: 1850px;
  }

  #rebateInformationDialog .modal-body {
    padding: 0px !important;
  }

  #rebateInformationDialog .modal-header {
    border-bottom: 0px !important;
  }

  #rebateInformationDialog tr:nth-child(even) {
    background: white;
  }

  #rebateInformationDialog tr:nth-child(odd) {
    background: lightgray;
  }

  .selectedRow {
    background-color: lightyellow !important;
    border: 1px thin #000;
  }

  .totalCash {
    background-color: lightgreen !important;
  }

  /* Other */
  #jsonInfoDialog .modal-lg {
    max-width: 1130px;
  }

  .selectwidthauto {
    width: auto !important;
  }

  .hidden_header {
    display: none;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 4s;
  }

  .expand-button-enter-active {
    transition: all .3s ease;
  }

  .expand-button-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }

  .tableFixHead {
    overflow-y: auto;
    height: 100px;
  }

    .tableFixHead th {
      position: sticky;
      top: 0;
      background: white;
    }

    .tableFixHead table {
      border-collapse: collapse;
      width: 100%;
    }

    .tableFixHead th, td {
    }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently                          supported by Chrome and Opera */
  }

  .doubleline {
    width: 100%;
    height:5px;
    background-color:#FFFFFF;
    border-bottom:3px solid;
    border-bottom-style: double;
  }
  .btn-calculate {
    background-color: #0C823D !important;
    color: white !important;
    font-size: 1rem !important;
    border-radius: 3px !important;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
    rgba(0, 0, 0, 0.06) 0px 2px 4px -1px !important;
  }
  .btn-json {
    font-size: 1rem !important;
    color: #0060A8 !important;
    background-color: white !important;
    border: solid 1px #0060A8 !important;
    border-radius: 3px !important;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px
  }
  .card {
    border-radius: 3px !important;
    box-shadow: rgba(0,0,0,0.1) 0px 4px 6px -1px, rgba(0,0,0,0.06) 0px 2px 4px -1px;
  }
  .card-dropdown {
    border-radius: 3px !important;
  }
  .btn-search {
    background-color: #FFFFFF !important;
    color: #7d7e7f !important;
    border-right: none !important;
    border-radius: 3px 0px 0px 0px !important;
    border-color: #c2cfd6 !important;
  }
</style>

<!---->



// WEBPACK FOOTER //
// src/views/APIDemo.vue